module.exports = __webpack_public_path__ + "img/project_14.0498cf2a.png";